import * as tslib_1 from "tslib";
var baseOldQuoteTarget = {
    mode: 'CALL_NEW_QUOTE_AUTO',
    shouldShowPasSelector: false
};
export var categories = [
    {
        id: 'categoria-automovil',
        fontIcon: 'vehiculo_automovil',
        text: 'Automovil',
        mode: 'EMBEDDED',
        route: '/auto-unified',
        shouldShowPasSelector: true
    },
    tslib_1.__assign({}, baseOldQuoteTarget, { id: 'categoria-camion', fontIcon: 'vehiculo_camion', text: 'Camión', categoryKey: 'B' }),
    tslib_1.__assign({}, baseOldQuoteTarget, { id: 'categoria-acoplado', fontIcon: 'vehiculo_acoplado', text: 'Acoplado', categoryKey: 'C' }),
    tslib_1.__assign({}, baseOldQuoteTarget, { id: 'categoria-tractor', fontIcon: 'vehiculo_tractor', text: 'Tractor / Máquina rural', categoryKey: 'D' }),
    tslib_1.__assign({}, baseOldQuoteTarget, { id: 'categoria-moto', fontIcon: 'vehiculo_moto', text: 'Moto', categoryKey: 'E' }),
    tslib_1.__assign({}, baseOldQuoteTarget, { id: 'categoria-minibus', fontIcon: 'vehiculo_minibus', text: 'Minibús', categoryKey: 'F' }),
    tslib_1.__assign({}, baseOldQuoteTarget, { id: 'categoria-motorhome', fontIcon: 'vehiculo_motorhome', text: 'Casa rodante', categoryKey: 'G' })
];
